import {
    ApartmentBuildingStatus,
    ExtendedConstructionNumber,
    ExtendedProjectPhase,
} from '../../api-utilities/api-utilities.types';
import { betweenDates, calculateDifferenceInDays } from '../../date';

const getApartmentBuildingStatus = (
    projectPhase: ExtendedProjectPhase,
    constructionNumbers?: ExtendedConstructionNumber[],
): ApartmentBuildingStatus | undefined => {
    const currentDate = new Date();
    const saleStartDate = projectPhase.saleStartDate && new Date(projectPhase.saleStartDate);
    const saleEndDate = projectPhase.saleEndDate && new Date(projectPhase.saleEndDate);
    const allocationDate = projectPhase.allocationDate && new Date(projectPhase.allocationDate);

    if (projectPhase.status === 'Sold') return 'UnderConstruction';
    if (projectPhase.status === 'Rented') return 'Rented';

    if (!constructionNumbers?.length) return getInPreparationStatus();

    switch (projectPhase.status) {
        case 'InPreparation':
            return getInPreparationStatus();
        case 'ForRent':
            return 'ForRent';
        case 'OnSale':
            return getOnSaleStatus();
        default:
            return;
    }

    function getInPreparationStatus(): ApartmentBuildingStatus {
        if (projectPhase.isRental) return 'InPreparation';

        if (saleStartDate) {
            const differenceInDays = calculateDifferenceInDays(saleStartDate, currentDate);

            if (differenceInDays <= 30) return 'SaleSoon';
        }

        return 'InPreparation';
    }

    function getOnSaleStatus(): ApartmentBuildingStatus | undefined {
        if (!saleStartDate || !saleEndDate || !allocationDate) return;

        const betweenSaleStartAndSaleEnd = betweenDates(saleStartDate, currentDate, saleEndDate);
        const betweenSaleStartAndAllocation = betweenDates(
            saleStartDate,
            currentDate,
            allocationDate,
        );
        const afterAllocation = currentDate >= allocationDate;

        if (betweenSaleStartAndSaleEnd) return 'SaleStarted';

        if (betweenSaleStartAndAllocation) return 'AssigningOn';

        if (afterAllocation) {
            const constructionNumberStatusses = constructionNumbers!.map(
                ({ availabilityStatus }) => availabilityStatus,
            );
            const constructionNumbersAvailable = constructionNumberStatusses.filter(
                (s) => s === 'Available',
            );
            const constructionNumbersInOption = constructionNumberStatusses.filter(
                (s) => s === 'InOption',
            );

            if (constructionNumbersAvailable.length) return 'AmountAvailable';

            if (constructionNumbersInOption.length) return 'InOption';

            if (constructionNumberStatusses.indexOf('Sold') > -1) return 'Sold';
        }

        return;
    }
};

export { getApartmentBuildingStatus };
